"use strict";
'use client';
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var apps_shared_1 = require("@l2p/apps-shared");
var swr_hooks_1 = require("@l2p/swr-hooks");
var ui_components_1 = require("@l2p/ui-components");
var Lockr = __importStar(require("lockr"));
var next_intl_1 = require("next-intl");
var link_1 = __importDefault(require("next/link"));
var react_1 = __importStar(require("react"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
Lockr.setPrefix('CLIENT_');
var ACCEPT_COOKIE = 'ACCEPT_COOKIE';
var AcceptCookies = function () {
    var globalConfig = (0, swr_hooks_1.useConfig)();
    var t = (0, next_intl_1.useTranslations)('acceptCookies');
    var _a = (0, react_1.useState)(), isAccepted = _a[0], setAccepted = _a[1];
    var getAcceptedFromCookie = (0, react_1.useCallback)(function () {
        return Lockr.get(ACCEPT_COOKIE);
    }, []);
    var breakpoints = (0, apps_shared_1.useBreakpoint)();
    var generateUrlWithLang = (0, apps_shared_1.useGenerateUrlWithLang)();
    (0, react_1.useEffect)(function () {
        setAccepted(getAcceptedFromCookie());
        //eslint-disable-next-line
    }, []);
    var setAcceptCookie = (0, react_1.useCallback)(function () {
        Lockr.set(ACCEPT_COOKIE, 'accepted');
        setAccepted(getAcceptedFromCookie());
    }, [getAcceptedFromCookie, setAccepted]);
    if (Object.keys(breakpoints).length === 0 ||
        isAccepted ||
        (globalConfig === null || globalConfig === void 0 ? void 0 : globalConfig.hideAcceptCookies))
        return null;
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.container },
        react_1.default.createElement("div", { className: styles_module_scss_1.default.content },
            react_1.default.createElement("div", { className: styles_module_scss_1.default.text },
                react_1.default.createElement("span", { className: styles_module_scss_1.default.upTo, dangerouslySetInnerHTML: {
                        __html: (breakpoints.mobile ? t('textMobile') : t('text')) + ' ',
                    } }),
                react_1.default.createElement(link_1.default, { href: generateUrlWithLang('/privacy-policy'), target: "_blank" }, t('privacyPolicyText'))),
            react_1.default.createElement("div", { className: styles_module_scss_1.default.btnWrap },
                react_1.default.createElement(ui_components_1.FixedButton, { variant: "outline", width: "110px", color: "blue", borderWidth: "2px", onClick: setAcceptCookie }, t('agree'))))));
};
exports.default = AcceptCookies;
